import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-export-modal',
  templateUrl: './export-modal.component.html',
  styleUrls: ['./export-modal.component.scss'],
  standalone: false,
})
export class ExportModalComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
